import { useQuery } from "@tanstack/react-query";
import { getJournalsByMemberId } from "@/services/firestore/journals";
import type { Journal } from "@vlab-corporation/vlab-pilates-service-interface/class";

export function useJournalHistory(
  ownerUid: string,
  centerId: number,
  studiomateMemberId: number | undefined,
  memberName?: string,
) {
  return useQuery<Journal[]>({
    queryKey: ["journalHistory", ownerUid, centerId, studiomateMemberId],
    queryFn: () => getJournalsByMemberId(ownerUid, centerId, studiomateMemberId!, memberName),
    enabled: !!ownerUid && !!centerId && studiomateMemberId !== undefined,
  });
}
